import { ContactType } from '@/core/domain/_shared/ContactType';
import { Contact } from '@/core/domain/people/_shared/Contact';
import { applyMask, removeMask } from '@/utils/mask';
import { cellphoneMask, phoneMask } from '@/utils/mask/commonMasks';
import { Space, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import useWindowSize from './useWindowSize';

export function useContactColumns<T extends Partial<Contact>>() {
  const { isMobile } = useWindowSize();

  const columns: ColumnsType<T> = [
    {
      title: 'Nome',
      key: 'name',
      dataIndex: 'name',
      render: (value) => value || '-',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'E-Mail',
      key: 'email',
      render: (_, row) => {
        const value = row.detailList?.find(
          (cur) => cur.contactType === 'EMAIL',
        )?.value;

        if (value) {
          return (
            <Space>
              <Typography.Text>{value}</Typography.Text>
            </Space>
          );
        } else {
          return '-';
        }
      },
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Whatsapp',
      key: 'whatsapp',
      render: (_, row) => {
        const value = row.detailList?.find(
          (cur) => cur.contactType === ContactType.WhatsApp,
        )?.value;

        if (value) {
          const wppNumber = `55${value.replace(/\D/g, '')}`;

          const urlQueryString = new URLSearchParams({
            phone: wppNumber,
          });

          let wppLink = '';

          if (isMobile) {
            wppLink = `https://wa.me/${wppNumber}?`;
          } else {
            wppLink = `https://web.whatsapp.com/send?${urlQueryString}`;
          }

          return (
            <Typography.Text
              onClick={() => window.open(wppLink, '_blank')}
              style={{ cursor: 'pointer' }}
            >
              {applyMask(removeMask(value), cellphoneMask)}
            </Typography.Text>
          );
        } else {
          return '-';
        }
      },
      width: 120,
      ellipsis: true,
    },
    {
      title: 'Celular',
      key: 'mobile',
      render: (_, row) => {
        const value = row.detailList?.find(
          (cur) => cur.contactType === ContactType.Mobile,
        )?.value;

        if (value) {
          return (
            <Tooltip title="Ligar para" trigger={['hover']}>
              <Typography.Text
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  window.open(`tel:+55${value.replace(/\D/g, '')}`)
                }
              >
                {applyMask(removeMask(value), cellphoneMask)}
              </Typography.Text>
            </Tooltip>
          );
        } else {
          return '-';
        }
      },
      width: 120,
      ellipsis: true,
    },
    {
      title: 'Telefone',
      key: 'phone',
      render: (_, row) => {
        const value = row.detailList?.find(
          (cur) => cur.contactType === ContactType.Phone,
        )?.value;

        if (value) {
          return (
            <Tooltip title="Ligar para" trigger={['hover']}>
              <Typography.Text
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  window.open(`tel:+55${value.replace(/\D/g, '')}`)
                }
              >
                {applyMask(removeMask(value), phoneMask)}
              </Typography.Text>
            </Tooltip>
          );
        } else {
          return '-';
        }
      },
      width: 120,
      ellipsis: true,
    },
    {
      title: 'Estrangeiro',
      key: 'foreign',
      width: 120,
      ellipsis: true,
      render: (_, row) => {
        const foreignContact = row.detailList?.find(
          ({ contactType }) => contactType === ContactType.Foreign,
        )?.value;

        return <Typography.Text>{foreignContact || '-'}</Typography.Text>;
      },
    },
  ];

  return { columns };
}
